'use strict';

var styled = require('styled-components');
var component = require('../Text/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const backgroundByAvatarColor = {
    blue: theme => theme.designTokens.avatarBlueBackground,
    green: theme => theme.designTokens.avatarGreenBackground,
    grey: theme => theme.designTokens.avatarGreyBackground,
    orange: theme => theme.designTokens.avatarOrangeBackground,
    purple: theme => theme.designTokens.avatarPurpleBackground,
    red: theme => theme.designTokens.avatarRedBackground,
};
const textColorByAvatarColor = {
    blue: theme => theme.designTokens.avatarBlueTextColor,
    green: theme => theme.designTokens.avatarGreenTextColor,
    grey: theme => theme.designTokens.avatarGreyTextColor,
    orange: theme => theme.designTokens.avatarOrangeTextColor,
    purple: theme => theme.designTokens.avatarPurpleTextColor,
    red: theme => theme.designTokens.avatarRedTextColor,
};
const sizeByAvatarSize = {
    s: theme => theme.designTokens.avatarSizeS,
    m: theme => theme.designTokens.avatarSizeM,
    l: theme => theme.designTokens.avatarSizeL,
};
const Container = styled__default.default.div `
  display: inline-flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  color: ${({ theme, color }) => textColorByAvatarColor[color](theme)};
  background: ${({ theme, color, src }) => `${backgroundByAvatarColor[color](theme)} url("${src}") no-repeat center`};
  background-size: cover;
  height: ${({ theme, size }) => sizeByAvatarSize[size](theme)};
  width: ${({ theme, size }) => sizeByAvatarSize[size](theme)};
`;
const StyledText = styled__default.default(component.Text) `
  color: inherit;
`;
const Styled = {
    Container,
    Text: StyledText,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
